// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS reset to prevent unwanted formatting at the root of the app */

/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    display: flex;
    box-sizing: border-box;
}

* {
    box-sizing: inherit;
}

body {
    line-height: 1;
}

html,
body,
#app {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

ol,
ul {
    list-style: none;
}

blockquote,
q {
    quotes: none;
}

    blockquote:before,
    blockquote:after,
    q:before,
    q:after {
        content: "";
        content: none;
    }

table {
    border-collapse: collapse;
    border-spacing: 0;
}

i {
    display: none;
}

.insights-formatted-text-spacing-container button, .insights-formatted-text-spacing-container textarea, .insights-formatted-text-spacing-container select {
    line-height: 1.5 !important;
    letter-spacing: 0.12em !important;
    word-spacing: 0.16em !important;
}

.refresh-page-title {
    grid-area: 2/1/2/3;
}

.ocvFeedbackLaunchButton {
    white-space: nowrap !important;
}

/* Reset display for OCV feedback dialog portal elements */
#inapp-feedback-element-id,
#inapp-feedback-element-id *,
[class*="ocv-inapp-feedback"],
[class*="ocv-inapp-feedback"] * {
    display: revert;
}
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;;;CAGC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAiFI,SAAS;IACT,UAAU;IACV,SAAS;IACT,eAAe;IACf,aAAa;IACb,wBAAwB;IACxB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB;;IAEI;;;;QAII,WAAW;QACX,aAAa;IACjB;;AAEJ;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,0DAA0D;AAC1D;;;;IAII,eAAe;AACnB","sourcesContent":["/* CSS reset to prevent unwanted formatting at the root of the app */\n\n/* http://meyerweb.com/eric/tools/css/reset/ \n   v2.0 | 20110126\n   License: none (public domain)\n*/\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n    display: flex;\n    box-sizing: border-box;\n}\n\n* {\n    box-sizing: inherit;\n}\n\nbody {\n    line-height: 1;\n}\n\nhtml,\nbody,\n#app {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n\nol,\nul {\n    list-style: none;\n}\n\nblockquote,\nq {\n    quotes: none;\n}\n\n    blockquote:before,\n    blockquote:after,\n    q:before,\n    q:after {\n        content: \"\";\n        content: none;\n    }\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\ni {\n    display: none;\n}\n\n.insights-formatted-text-spacing-container button, .insights-formatted-text-spacing-container textarea, .insights-formatted-text-spacing-container select {\n    line-height: 1.5 !important;\n    letter-spacing: 0.12em !important;\n    word-spacing: 0.16em !important;\n}\n\n.refresh-page-title {\n    grid-area: 2/1/2/3;\n}\n\n.ocvFeedbackLaunchButton {\n    white-space: nowrap !important;\n}\n\n/* Reset display for OCV feedback dialog portal elements */\n#inapp-feedback-element-id,\n#inapp-feedback-element-id *,\n[class*=\"ocv-inapp-feedback\"],\n[class*=\"ocv-inapp-feedback\"] * {\n    display: revert;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
